import { takeLatest } from "redux-saga/effects";

import * as ActionsTypes from "../../../../../../common/state/StatesConstants";
import { addInformationCompanySaga, editInformationCompanySaga } from "./InformationCompanySaga";

export default function* InformationCompanysWatcher() {
  yield takeLatest(ActionsTypes.ADD_INFORMATION_COMPANY, addInformationCompanySaga);
  yield takeLatest(ActionsTypes.EDIT_INFORMATION_COMPANY, editInformationCompanySaga);
}
